import AdminMainHeader from './admin-main-header.vue';

AdminMainHeader.install = function(Vue) {
    Vue.component(AdminMainHeader.name, AdminMainHeader);
};

export { AdminMainHeader };